module.exports = __webpack_public_path__ + "static/media/EmStyleOutcomesRegistry-side-box.db2c52af.png";